import { MyInvitationEffects } from "@my-account/store/effects/my-invitation.effects";
import { MyRoleAssignmentEffects } from "@my-account/store/effects/my-role-assignment.effects";

export const effects = [MyInvitationEffects, MyRoleAssignmentEffects];

export * from "@my-account/store/effects/my-invitation.effects";
export * from "@my-account/store/effects/my-role-assignment.effects";
